import React, { useEffect, useState } from "react";
import { FormControl } from "@mui/material";
import InputAdornment from "@mui/material/InputAdornment";
import CVV from "../../assets/svg/CVV.svg";
import CardImage from "../../assets/image/icons/CreditCard.png";
import InputText from "../InputFields/InputText";
import "./style.css";
import { Grid } from "@mui/material";
import { getCardImageFromNumber } from "../../utils/cardImageHelper";

function PaymentInfo({
  formik,
  handleChange,
  expireMonth,
  expireYear,
  handleYearChange,
  disabled,
}) {
  const [cardImage, setCardImage] = useState(CardImage);
  useEffect(() => {
    const fetchCardImage = async () => {
      try {
        // Use free card image API - no rate limits, supports all card types worldwide
        if (formik?.values?.CardNumber) {
          const imageUrl = await getCardImageFromNumber(formik.values.CardNumber);
          setCardImage(imageUrl || CardImage);
        } else {
          setCardImage(CardImage);
        }
      } catch (error) {
        setCardImage(CardImage);
      }
    };
    fetchCardImage();
  }, [formik?.values?.CardNumber]);

  const handleNameChange = (e, formik, fieldName) => {
    let value = e?.target?.value;
    // Remove any non-alphabetic characters except spaces
    value = value.replace(/[^A-Za-z\s]/g, "");
    formik.setFieldValue(fieldName, value);
  };

  const handleCardNumberChange = (e, formik) => {
    let value = e?.target?.value;

    value = value.replace(/\D/g, "");

    if (value?.length > 16) {
      value = value?.slice(0, 19);
    }

    let formattedValue = "";
    for (let i = 0; i < value?.length; i++) {
      if (i > 0 && i % 4 === 0) {
        formattedValue += " ";
      }
      formattedValue += value[i] || "";
    }

    formik.setFieldValue("CardNumber", formattedValue);
  };

  return (
    <Grid>
      <Grid className="d-flex gap-2 mt-2 first-section-payment">
        <FormControl style={{ marginBottom: "16px" }} className="w-50 form">
          <InputText
            value={formik?.values?.FirstName}
            onChange={(e) => handleNameChange(e, formik, "FirstName")}
            onBlur={formik?.handleBlur}
            error={
              formik?.touched?.FirstName && Boolean(formik?.errors?.FirstName)
            }
            helperText={formik?.touched?.FirstName && formik?.errors?.FirstName}
            name="FirstName"
            label="First Name"
            type="text"
            className="text-blue-color w-100"
            fieldHeight="44px"
            disable={disabled}
          />
        </FormControl>
        <FormControl style={{ marginBottom: "16px" }} className="w-50 form">
          <InputText
            value={formik?.values?.LastName}
            onChange={(e) => handleNameChange(e, formik, "LastName")}
            onBlur={formik?.handleBlur}
            error={
              formik?.touched?.LastName && Boolean(formik?.errors?.LastName)
            }
            helperText={formik?.touched?.LastName && formik?.errors?.LastName}
            name="LastName"
            label="Last Name"
            type="text"
            className="text-blue-color w-100"
            fieldHeight="44px"
            disable={disabled}
          />
        </FormControl>
      </Grid>
      <Grid className="mb-4">
        <InputText
          value={formik?.values?.CardNumber}
          onChange={(e) => handleCardNumberChange(e, formik)}
          onBlur={formik?.handleBlur}
          error={
            formik?.touched?.CardNumber && Boolean(formik?.errors?.CardNumber)
          }
          helperText={formik?.touched?.CardNumber && formik?.errors?.CardNumber}
          name="CardNumber"
          label="Card Number"
          type="text"
          disabled={disabled}
          className="text-blue-color w-100"
          fieldHeight="44px"
          endAdornment={
            <InputAdornment position="end" className="p-0 m-0">
              <img
                src={cardImage}
                alt="CVV"
                style={{
                  padding: 0,
                  margin: 0,
                  width: "36px",
                  height: "30px",
                }}
              />
            </InputAdornment>
          }
        />
      </Grid>
      <Grid className="d-flex gap-2 cvv">
        <Grid className="d-flex gap-2 w-50 date">
          <FormControl
            style={{ marginBottom: "16px" }}
            className="w-100 paymentt"
          >
            <InputText
              select
              id="MM"
              name="ExpireMonth"
              label="Month"
              placeholder="MM"
              className="text-blue-color border-blue-color w-100"
              disable={disabled}
              value={formik?.values?.ExpireMonth ?? ""}
              onChange={handleChange}
              SelectProps={{ native: true }}
              fieldHeight="44px"
              fullWidth
              error={
                formik?.touched?.ExpireMonth &&
                Boolean(formik?.errors?.ExpireMonth)
              }
              helperText={
                formik?.touched?.ExpireMonth && formik?.errors?.ExpireMonth
              }
            >
              <option value="">Month</option>
              {expireMonth.map((month) => (
                <option key={month} value={month}>
                  {month}
                </option>
              ))}
            </InputText>
          </FormControl>

          <FormControl
            style={{ marginBottom: "16px" }}
            className="w-100 paymentt paymentInformationDateSelect"
          >
            <InputText
              select
              id="YY"
              name="ExpireYear"
              label="Year"
              placeholder="YY"
              className="text-blue-color border-blue-color w-100"
              disable={disabled}
              value={formik?.values?.ExpireYear ?? ""}
              onChange={(e) => {
                handleChange(e);
                handleYearChange(e);
              }}
              SelectProps={{ native: true }}
              fieldHeight="44px"
              fullWidth
              error={
                formik?.touched?.ExpireYear &&
                Boolean(formik?.errors?.ExpireYear)
              }
              helperText={
                formik?.touched?.ExpireYear && formik?.errors?.ExpireYear
              }
            >
              <option value="">Year</option>
              {expireYear.map((year) => (
                <option key={year} value={year}>
                  {year}
                </option>
              ))}
            </InputText>
          </FormControl>
        </Grid>
        <FormControl style={{ marginBottom: "16px" }} className="w-50 abcd">
          <InputText
            value={formik?.values?.CVVNumber}
            onChange={(e) => {
                let value = e?.target?.value?.replace(/\D/g, "");

              if (value?.length <= 4) {
                formik?.setFieldValue("CVVNumber", value);
              }
            }}
            onBlur={formik?.handleBlur}
            error={
              formik?.touched?.CVVNumber && Boolean(formik?.errors?.CVVNumber)
            }
            helperText={formik?.touched?.CVVNumber && formik?.errors?.CVVNumber}
            name="CVVNumber"
            label="CVV"
            type="text"
            className="text-blue-color w-100"
            fieldHeight="44px"
            InputLabelProps={{
              style: { fontSize: "15px", marginLeft: "5px" },
            }}
            sx={{
              "& .MuiOutlinedInput-root": {
                height: "44px",
                "& fieldset": {
                  borderRadius: "6px",
                  padding: "13px 12px",
                  height: "44px",
                },
                "&:hover fieldset": {},
                "&.Mui-focused fieldset": {},
              },
              "& .MuiInputLabel-root": {
                marginLeft: "5px",
              },
            }}
            inputProps={{
              maxLength: 4,
            }}
            endAdornment={
              <InputAdornment position="end" className="p-0 m-0">
                <img
                  src={CVV}
                  alt="CVV"
                  style={{
                    padding: 0,
                    margin: 0,
                    width: "auto",
                  }}
                />
              </InputAdornment>
            }
          />
        </FormControl>
      </Grid>
    </Grid>
  );
}

export default PaymentInfo;
